import BreadcrumbLink from "components/elements/Breadcrumbs/BreadcrumbLink";
import AssetTypeIcon from "components/elements/Chip/AssetTypeIcon";
import { useAsset } from "lib/hooks/assets/useAsset";
import { UrlObject } from "url";
import BreadcrumbMiddleTruncatedText from "components/elements/Breadcrumbs/BreadcrumbMiddleTruncatedText";

export default function BreadcrumbAsset(p: {
  params: string[];
  href: UrlObject;
}) {
  const assetId = p.params[0] && +p.params[0];
  const { asset } = useAsset(assetId);
  return (
    <BreadcrumbLink href={p.href}>
      <AssetTypeIcon
        type={asset?.type}
        ext={asset?.extension}
        width="w-4 shrink-0"
      />
      <BreadcrumbMiddleTruncatedText
        text={asset?.aliasName || asset?.nameWithoutExtension || "Asset"}
      />
    </BreadcrumbLink>
  );
}
